module.exports = __webpack_public_path__ + "img/logo.dffd599d.webp";